<template>
  <content-layout>
    <div slot="content_container">
      <div class="row mt-4">
        <div class="col-1 desktop"></div>

        <!-- content section-->
        <section
            class="col-9"
            :class="{'col-12': windowWidth <= 1200}"
            style="text-align: left">
          <!-- search by -->
          <search-by-card
              :_on-click-cb="onSearchAccount">
          </search-by-card>

          <form v-if="mSearchBy.result" class="form-group" v-on:submit.prevent="onAddInventory()">
            <label>Add New Router:</label>
            <div class="d-flex flex-row justify-content-between">
              <input type="text"
                     class="form-control"
                     placeholder="MAC Address"
                     v-model="mAddInventory.data.macAddress"
                     v-bind:disabled="mAddInventory.disabled">
              <input type="text"
                     class="form-control ml-2"
                     placeholder="Serial Number"
                     v-model="mAddInventory.data.serialNumber"
                     v-bind:disabled="mAddInventory.disabled">
            </div>
            <div class="mt-2">
              <b-form-select v-model="mAddInventory.data.hardwareKey"
                             :options="mAddInventory.hardwareOptions"></b-form-select>
            </div>
            <div class="d-flex flex-row justify-content-end mt-4">
              <button type="submit"
                      class="btn btn-outline-primary ml-2"
                      style="width: 10rem"
                      v-bind:disabled="!mAddInventory.isValid()">
                Add
              </button>
            </div>

          </form>

          <!-- search result -->
          <div>
            <label class="label">Inventory Items:</label>
            <div class="card">
              <div class="card-body">
                <div v-if="mSearchBy.result && mSearchBy.result.hasDevices()">
                  <div v-for="(data, dataIndex) in mSearchBy.result.getDevices()"
                       class="pt-1 pb-2"
                       :class="{'divider': mSearchBy.result.hasMultipleDevices() && dataIndex < (mSearchBy.result.length - 1)}"
                       style="min-height: 7rem;"
                       v-bind:key="dataIndex">
                    <div class="row">
                      <div class="col-sm-8">
                        <div v-for="(item, itemIndex) in data.formattedData()"
                             v-bind:key="itemIndex">
                          <span class="label">{{ item.text }} <span class="description"> {{ item.value }}</span></span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <button type="submit"
                                class="btn btn-outline-primary"
                                :class="{
                                    'btn-fixed': windowWidth >= 576,
                                    'btn-fill': windowWidth < 576,
                                    }"
                                style="margin-top: 1.6rem; float: right"
                                v-on:click.prevent="onRemoveDevice(data.getItemId())">
                          {{ 'Remove'}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="d-flex justify-content-center">
                  <label>No Routers found</label>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="col-2 desktop"></div>
      </div>
    </div>
  </content-layout>
</template>

<script>
import webapi from "@/webapi"
// import model from "@/model"
import ContentLayout from "@/components/content_layout"
import SearchByCard from "@/views/content/components/search_by_card"
// import displayHelper from "@/util/display_helper"
import logger from "@/util/logger"
import model from "@/model";

const LOG_TAG = 'inventory';
export default {
  name: LOG_TAG,
  display: 'Inventory',
  route: `customer_services.${LOG_TAG}`,
  components: {
    ContentLayout,
    SearchByCard,
  },
  data() {
    return {
      mSearchBy: {
        data: null,
        result: null,
        isValid() {
          return this.result && this.result.hasDevices();
        },
        clear() {
          this.result = null;
        }
      },
      mAddInventory: {
        disabled: false,
        data: {
          serialNumber: '',
          macAddress: '',
          hardwareKey: '',
        },
        hardwareOptions: [
          {text: 'Select Router Model', value: ''},
          {text: 'AR2140', value: 'AR2140'},
          {text: 'AR1344E', value: 'AR1344E'},
        ],
        isValid() {
          return this.data.serialNumber && this.data.macAddress && this.data.hardwareKey;
        },
        clear() {
          this.data.serialNumber = '';
          this.data.macAddress = '';
          this.data.hardwareKey = '';
        }
      }
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  mounted() {
  },
  methods: {
    onSearchAccount(data) {
      const vm = this;
      logger.d(LOG_TAG, 'onSearchAccount', data);
      vm.mSearchBy.data = data;
      vm.mSearchBy.clear();
      vm.mAddInventory.clear();
      if (data.providerAccountId) {
        webapi.configurationService.getInventoryByAccountId(
          data.providerAccountId,
          (responseData) => {
            let modelData = model.configurationInventoryResponse(responseData);
            vm.mSearchBy.result = modelData;
            logger.d(LOG_TAG, 'onSearchAccount', 'getInventoryByAccountId', vm.mSearchBy.result.hasDevices());
            modelData.getDevices().forEach((device) => {
              logger.d(LOG_TAG, 'onSearchAccount', 'getInventoryByAccountId', device.getItemId(), device.getModel());
            });
          }, (error) => {
              logger.w(LOG_TAG, 'onSearchAccount', 'getInventoryByAccountId', error);
          }
        )
      } else {
        webapi.configurationService.getInventoryByHouseAndAccountNumber(
            data.houseNumber,
            data.accountNumber,
            (responseData) => {
              logger.d(LOG_TAG, 'onSearchAccount', 'getInventoryByHouseAndAccountNumber', responseData);
            }, (error) => {
              logger.w(LOG_TAG, 'onSearchAccount', 'getInventoryByHouseAndAccountNumber', error);
            }
        )
      }
    },
    onRemoveDevice(deviceId) {
      const vm = this;
      logger.d(LOG_TAG, 'onRemoveDevice', deviceId);
      const searchBy = vm.mSearchBy.data;
      webapi.configurationService.removeInventory(
          searchBy.providerAccountId, searchBy.houseNumber, searchBy.accountNumber,
          deviceId,
          (responseData) => {
            logger.d(LOG_TAG, 'onRemoveDevice', responseData);
            vm.onSearchAccount(searchBy);
          },
          (error) => {
            logger.w(LOG_TAG, 'onRemoveDevice', error);
          }
      )
    },
    onAddInventory() {
      const vm = this;
      logger.d(LOG_TAG, 'onAddInventory');
      const searchBy = vm.mSearchBy.data;
      const inventoryData = vm.mAddInventory.data;
      webapi.configurationService.addInventory(
        searchBy.providerAccountId, searchBy.houseNumber, searchBy.accountNumber,
        inventoryData.hardwareKey, inventoryData.macAddress, inventoryData.serialNumber,
        (responseData) => {
          logger.d(LOG_TAG, 'onAddInventory', responseData);
          vm.onSearchAccount(searchBy);
        },
        (error) => {
          logger.w(LOG_TAG, 'onAddInventory', error);
        }
      )
    }
  }
}
</script>

<style scoped>
.label {
  font-weight: bold;
}
.description {
  font-weight: lighter;
  font-size: smaller;
}
.btn-fixed {
  width: 8rem;
}
.btn-fill {
  width: 100%;
}
.divider {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom-style: dotted;
  border-width: 0.05rem;
  border-color: lightgrey
}
.divider.line {
  border-bottom-style: double;
  border-width: 0.2rem;
}

</style>
